import forkicon from "./forkicon.svg";

export default function ForkIcon() {
  return (
    <img src={forkicon} />
  );
}